import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "generateButton"]
  
  connect() {
    console.log('Password generator controller connected')
  }
  
  generate(event) {
    event.preventDefault()
    
    const password = this.generateSecurePassword()
    
    // Set both password fields
    this.passwordTarget.value = password
    this.confirmationTarget.value = password
    
    // Optional: Show the password to the user
    this.passwordTarget.type = "text"
    this.confirmationTarget.type = "text"
    
    // Hide password after 5 seconds
    setTimeout(() => {
      this.passwordTarget.type = "password"
      this.confirmationTarget.type = "password"
    }, 5000)
  }
  
  generateSecurePassword() {
    const length = 16
    const lowercase = 'abcdefghijklmnopqrstuvwxyz'
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const numbers = '0123456789'
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?'
    const allChars = lowercase + uppercase + numbers + symbols
    
    let password = ''
    
    // Ensure at least one of each type
    password += lowercase[Math.floor(Math.random() * lowercase.length)]
    password += uppercase[Math.floor(Math.random() * uppercase.length)]
    password += numbers[Math.floor(Math.random() * numbers.length)]
    password += symbols[Math.floor(Math.random() * symbols.length)]
    
    // Fill the rest randomly
    for (let i = password.length; i < length; i++) {
      password += allChars[Math.floor(Math.random() * allChars.length)]
    }
    
    // Shuffle the password
    return password.split('').sort(() => 0.5 - Math.random()).join('')
  }
}